exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-[slug]-js": () => import("./../../../src/pages/[slug].js" /* webpackChunkName: "component---src-pages-[slug]-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-wp-post-uri-js": () => import("./../../../src/pages/{wpPost.uri}.js" /* webpackChunkName: "component---src-pages-wp-post-uri-js" */)
}

